import React, { FC, PropsWithChildren, ReactNode } from "react";

import { TitleHeader } from "@xapp/components";

import styles from "./PageHeader.module.scss";

export interface PageHeaderProps {
    /** The page title, left justified. */
    readonly title: string | JSX.Element;
    /** An optional second row inside the sticky header, e.g. a filter bar. */
    readonly below?: ReactNode;
    readonly className?: string;
}

/**
 * The standard page header: the page title on the left and its actions (Save, Delete, filters…)
 * on the right, stuck to the top while the page scrolls. Pass actions as children. Pair with
 * the "full" page layout, which is the scroll container this sticks within.
 */
export const PageHeader: FC<PropsWithChildren<PageHeaderProps>> = ({ title, below, className, children }) => (
    <div data-page-header className={`${styles.pageHeader} ${className || ""}`}>
        <TitleHeader static={true} value={title}>
            {children}
        </TitleHeader>
        {below}
    </div>
);
